/* Whisply product card + quick-buy (port of live whisply-quickbuy.js, new scheme).
   Card hooks (snippets/wn-card.liquid):
     [data-wn-qa="variantId"]          one-variant "Frame +" → adds immediately
     [data-wn-qb="handle"][data-mode]  opens the quick-buy modal (frame | rx)
     [data-wn-dot]                     colour dot → swaps card image + target variant
   Cart contract: POST /cart/add.js, then document 'wn:cart:refresh' {detail:{open:true}}.
   Exposes window.WN.addToCart(items, button?) → Promise. */
(function () {
  'use strict';
  var WN = window.WN = window.WN || {};
  if (WN.__qb) return; WN.__qb = 1;
  var root = WN.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clean = function (v) { return String(v || '').replace(/\s*[-–]\s*low stock/i, '').replace(/\s*\(new\)/i, '').trim(); };
  var fmt = function (c) { var d = (c / 100).toFixed(2); return '$' + (d.slice(-3) === '.00' ? d.slice(0, -3) : d); };
  var sized = function (src, w) { if (!src) return ''; var u = src.indexOf('//') === 0 ? 'https:' + src : src; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };

  function toast(msg) {
    if (window.WNCart && typeof WNCart.toast === 'function') return WNCart.toast(msg);
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('on'); clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }
  WN.toast = WN.toast || toast;

  function addToCart(items, btn) {
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    if (window.WNCart && typeof WNCart.add === 'function') {
      return Promise.resolve(WNCart.add(items)).finally(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } });
    }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function (j) {
        document.dispatchEvent(new CustomEvent('wn:cart:refresh', { detail: { open: true } }));
        return j;
      })
      .finally(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } });
  }
  WN.addToCart = addToCart;

  /* ---------- card: colour dots ---------- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-wn-dot]');
    if (!dot) return;
    e.preventDefault();
    var card = dot.closest('[data-wn-card]'); if (!card) return;
    $$('[data-wn-dot]', card).forEach(function (d) { d.setAttribute('aria-pressed', String(d === dot)); });
    var img = $('.pc-img1', card);
    if (img && dot.dataset.src) { img.removeAttribute('srcset'); img.src = dot.dataset.src; }
    var qa = $('[data-wn-qa]', card); if (qa) qa.dataset.wnQa = dot.dataset.id;
    $$('[data-wn-qb]', card).forEach(function (b) { b.dataset.variant = dot.dataset.id; });
    var link = $('.pc-media', card); if (link && dot.dataset.id) { var u = link.getAttribute('href').split('?')[0]; link.setAttribute('href', u + '?variant=' + dot.dataset.id); }
  });

  /* ---------- card: one-variant quick add ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wn-qa]');
    if (!b) return;
    e.preventDefault();
    addToCart([{ id: +b.dataset.wnQa, quantity: 1 }], b)
      .then(function () { toast((b.dataset.title || 'Item') + ' added'); })
      .catch(function (err) { toast(err.message); });
  });

  /* ---------- quick-buy modal ---------- */
  var qb = document.getElementById('WNQuickBuy');
  if (!qb) {
    // no modal on the page: fall back to the product page
    window.WNQuickBuy = { open: function (h, o) { var m = o && (o.nodeType === 1 ? o.getAttribute('data-mode') : o.mode); location.href = root + 'products/' + h + (m === 'rx' ? '?rx=1' : ''); }, close: function () {} };
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wn-qb]'); if (!t) return;
      if (t.tagName !== 'A') { e.preventDefault(); location.href = root + 'products/' + t.dataset.wnQb + (t.dataset.mode === 'rx' ? '?rx=1' : ''); }
    });
    return;
  }
  var els = {
    panel: $('.qb-panel', qb), img: $('[data-qb-img]', qb), title: $('[data-qb-title]', qb), eyebrow: $('[data-qb-eyebrow]', qb),
    price: $('[data-qb-price]', qb), was: $('[data-qb-was]', qb), save: $('[data-qb-save]', qb), opts: $('[data-qb-opts]', qb),
    rxWrap: $('[data-qb-rx]', qb), err: $('[data-qb-err]', qb), add: $('[data-qb-add]', qb), label: $('[data-qb-label]', qb), sum: $('[data-qb-sum]', qb), link: $('[data-qb-link]', qb),
    flags: $('[data-qb-flags]', qb)
  };
  var product = null, variant = null, colorIdx = -1, lastFocus = null, rx = null, cache = {}, qty = 1, mode0 = "frame";
  var qtyWrap = $("[data-qb-qtywrap]", qb), qtyOut = $("[data-qb-qty]", qb);
  function setQty(n) { qty = Math.max(1, Math.min(9, n)); if (qtyOut) qtyOut.textContent = qty; label(); }
  $$("[data-qb-q]", qb).forEach(function (b) { b.addEventListener("click", function () { setQty(qty + +b.dataset.qbQ); }); });

  function initRx() {
    if (rx || !els.rxWrap || !window.WNRx) return;
    rx = WNRx.mount($('[data-wn-rx]', els.rxWrap), { onChange: function (s) {
      els.eyebrow.textContent = s.mode === 'rx' ? 'Frame with prescription lenses' : (mode0 === 'rx' ? 'Frame with blue light lenses' : 'Quick add');
      label();
    } });
  }
  function rxMode() { return rx ? rx.mode() : 'frame'; }
  /* mobile sheet scrolls as a whole (image included); desktop scrolls the right column */
  function scroller() { return /auto|scroll/.test(getComputedStyle(els.panel).overflowY) ? els.panel : $('.qb-scroll', qb); }
  /* the footer error clears as soon as the customer edits the prescription */
  if (els.rxWrap) els.rxWrap.addEventListener('change', function () { els.err.hidden = true; });
  /* choosing PRESCRIPTION brings the lens choice to the top of the sheet so the form below is in view */
  if (els.rxWrap) els.rxWrap.addEventListener('click', function (e) {
    if (!e.target.closest('[data-rx-mode="rx"]')) return;
    var sc = scroller(), lab = $('.rxw-label', els.rxWrap) || els.rxWrap;
    requestAnimationFrame(function () {
      var y = lab.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 20;
      if (y - sc.scrollTop > sc.clientHeight * 0.25) sc.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  });

  function label() {
    if (!variant) return;
    if (product) { var base = (product.url || root + 'products/' + product.handle).split('?')[0]; els.link.href = base + '?variant=' + variant.id + (mode0 === 'rx' && rxMode() === 'rx' ? '&rx=1' : ''); }
    if (!variant.available) { els.label.textContent = 'Sold out'; if (els.sum) els.sum.textContent = ''; els.add.disabled = true; return; }
    els.add.disabled = false;
    var withRx = rx && mode0 === 'rx' && rxMode() === 'rx';
    var q = withRx || mode0 === 'rx' ? 1 : qty;
    var total = fmt((variant.price + (withRx ? rx.fee().price : 0)) * q);
    if (els.sum) { els.label.textContent = 'Add to bag'; els.sum.textContent = total; }
    else els.label.textContent = 'Add to bag · ' + total;
    els.add.setAttribute('aria-label', 'Add to bag, ' + total + (withRx ? ', with prescription lenses' : ''));
  }
  function pick(v) {
    variant = v;
    var src = (v.featured_image && v.featured_image.src) || product.featured_image;
    if (els.img.dataset.src !== src) {
      els.img.style.opacity = '0';
      els.img.onload = function () { els.img.style.opacity = '1'; };
      els.img.src = sized(src, 1200); els.img.dataset.src = src;
      els.img.alt = product.title + (colorIdx > -1 ? ' in ' + clean(v.options[colorIdx]) : '');
    }
    els.price.textContent = fmt(v.price);
    var save = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
    els.was.hidden = !save; els.was.textContent = fmt(v.compare_at_price || 0);
    els.save.hidden = !save; els.save.textContent = 'Save ' + fmt(save);
    $$('[data-qb-val]', els.opts).forEach(function (b) { b.setAttribute('aria-pressed', String(v.options[+b.dataset.oi] === b.dataset.qbVal)); });
    $$('[data-qb-optlabel]', els.opts).forEach(function (l) { l.textContent = clean(v.options[+l.dataset.oi]); });
    label();
  }
  function renderOptions() {
    els.opts.innerHTML = '';
    if (product.variants.length < 2) return;
    product.options.forEach(function (opt, oi) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = []; product.variants.forEach(function (v) { if (values.indexOf(v.options[oi]) < 0) values.push(v.options[oi]); });
      var isColor = oi === colorIdx;
      var f = document.createElement('div'); f.className = 'qb-opt';
      f.innerHTML = '<span class="qb-optname"></span><div class="qb-vals" role="group"></div>';
      var nm = $('.qb-optname', f); nm.textContent = (isColor && /colou?r/i.test(name) ? 'Colour' : name) + ' ';
      var b0 = document.createElement('b'); b0.setAttribute('data-qb-optlabel', ''); b0.dataset.oi = oi; nm.appendChild(b0);
      var wrap = $('.qb-vals', f); wrap.setAttribute('aria-label', name);
      values.forEach(function (val) {
        var v = product.variants.filter(function (x) { return x.options[oi] === val; })[0];
        var b = document.createElement('button'); b.type = 'button'; b.dataset.qbVal = val; b.dataset.oi = oi; b.title = clean(val); b.setAttribute('aria-label', clean(val));
        if (isColor && v && v.featured_image) { b.className = 'qb-sw'; var im = document.createElement('img'); im.src = sized(v.featured_image.src, 200); im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
        else { b.className = 'qb-pill'; b.textContent = clean(val); }
        if (v && !v.available) b.classList.add('is-out');
        b.addEventListener('click', function () {
          var cur = variant.options.slice(); cur[oi] = val;
          var m = product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === cur[i]; }); })[0]
            || product.variants.filter(function (x) { return x.options[oi] === val && x.available; })[0] || v;
          pick(m);
        });
        wrap.appendChild(b);
      });
      els.opts.appendChild(f);
    });
  }

  function open(handle, mode, trigger) {
    lastFocus = trigger || document.activeElement;
    els.err.hidden = true;
    qb.hidden = false;
    requestAnimationFrame(function () { qb.classList.add('on'); });
    document.documentElement.classList.add('wn-lock');
    qb.classList.add('is-loading');
    initRx();
    var p = cache[handle] ? Promise.resolve(cache[handle]) : fetch(root + 'products/' + handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) { return (cache[handle] = j); });
    p.then(function (prod) {
      product = prod;
      qb.classList.remove('is-loading');
      colorIdx = -1;
      product.options.forEach(function (o, i) { if (colorIdx < 0 && /colou?r|lens/i.test(typeof o === 'string' ? o : o.name)) colorIdx = i; });
      els.title.textContent = product.title;
      els.flags.hidden = (WN.topSellers || []).indexOf(product.handle) < 0;
      els.link.href = product.url || root + 'products/' + handle;
      renderOptions();
      var want = trigger && trigger.dataset.variant ? +trigger.dataset.variant : 0;
      pick(product.variants.filter(function (v) { return v.id === want; })[0] || product.variants.filter(function (v) { return v.available; })[0] || product.variants[0]);
      mode0 = mode === 'rx' && rx ? 'rx' : 'frame';
      qb.setAttribute('data-qb-mode', mode0);
      if (qtyWrap) qtyWrap.hidden = mode0 === 'rx';
      setQty(1);
      if (els.rxWrap) {
        els.rxWrap.hidden = mode0 !== 'rx';
        if (rx) { rx.reset(); rx.setMode(mode0); }
      }
      els.eyebrow.textContent = mode0 === 'rx' ? (rxMode() === 'rx' ? 'Frame with prescription lenses' : 'Frame with blue light lenses') : 'Quick add';
      label();
      $('.qb-scroll', qb).scrollTop = 0; els.panel.scrollTop = 0;
      setTimeout(function () { els.panel.focus({ preventScroll: true }); }, 60);
    }).catch(function () { close(); location.href = root + 'products/' + handle; });
  }
  function close() {
    qb.classList.remove('on');
    document.documentElement.classList.remove('wn-lock');
    setTimeout(function () { if (!qb.classList.contains('on')) qb.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  els.add.addEventListener('click', function () {
    if (!variant || !variant.available) return;
    els.err.hidden = true;
    if (rx && mode0 === 'rx' && rxMode() === 'rx') {
      var msg = rx.validate();
      if (msg) { els.err.textContent = msg; els.err.hidden = false; return; }
    }
    var items = rx && mode0 === 'rx' && rxMode() === 'rx' ? rx.items(variant.id, 1) : [{ id: variant.id, quantity: mode0 === 'rx' ? 1 : qty }];
    els.label.textContent = 'Adding to bag'; if (els.sum) els.sum.textContent = '';
    addToCart(items, els.add).then(function () { label(); close(); }).catch(function (e) { label(); els.err.textContent = e.message || 'Could not add to bag'; els.err.hidden = false; });
  });
  qb.addEventListener('click', function (e) { if (e.target.closest('[data-qb-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (!qb.classList.contains('on')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') { // focus trap
      var f = $$('button:not([disabled]),a[href],select,input,[tabindex]:not([tabindex="-1"])', qb).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wn-qb]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    open(t.dataset.wnQb, t.dataset.mode, t);
  }, true);
  WN.quickBuy = { open: open, close: close };
  /* public API: WNQuickBuy.open(handle, {mode, source, variant}) or WNQuickBuy.open(handle, triggerElement) */
  window.WNQuickBuy = { open: function (handle, o) {
    if (o && o.nodeType === 1) return open(handle || o.getAttribute('data-wn-qb'), o.getAttribute('data-mode') === 'rx' ? 'rx' : 'frame', o);
    o = o || {};
    var t = null; if (o.variant) { t = document.createElement('span'); t.dataset.variant = o.variant; }
    open(handle, o.mode === 'rx' ? 'rx' : 'frame', o.trigger || t);
  }, close: close };
})();
